import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";

@Component({
  selector: "locked-row",
  template:
    "<i *ngIf=\"!omitRow\" [ngClass]=\"{'icon':true, 'icon_ion_lock_filled': locked, 'icon-lock_open': !locked, 'disabled': params.data != null && params.data.processing === true}\" (click)=\"toggleLock()\">&nbsp;</i>",
  standalone: false,
})
export class LockedStagingRowRenderer implements ICellRendererAngularComp {
  public params: any;
  public locked: boolean;
  public omitRow: boolean = false;

  // called on init
  agInit(params: any): void {
    this.doVal(params);
  }

  doVal(params: any): void {
    this.params = params;
    this.omitRow = params != null && params.data != null && params.data.bulkEditRow;
    this.locked = params.data.locked;
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.doVal(params);
    return true;
  }

  toggleLock() {
    if (this.params != null && this.params.data != null) {
      this.params.context.toggleLocked(this.params.data.id);
    }
  }
}
